import { isCardViewAtom } from "@/core/reatom/state/CardView";
import {
  isLoadingSearchAtom,
  paramsAtom,
  searchAction,
  searchAtom,
  searchListScrollPositionAtom,
} from "@/core/reatom/state/search";
import { SearchParams } from "@/core/reatom/state/search/types";
import { useAction, useAtom } from "@reatom/npm-react";
import clsx from "clsx";
import { VirtuosoGrid } from "react-virtuoso";
import { Card } from "../Card/Card";
import { CardViewSwithcer } from "../CardViewSwithcer/CardViewSwithcer";
import s from "./style.module.scss";
import { SpinLoader } from "../SpinLoader/SpinLoader";

const LOADING_LIMIT = 6;

export const Services = () => {
  const [isCardView] = useAtom(isCardViewAtom);
  const [search] = useAtom(searchAtom);
  const [isLoading] = useAtom(isLoadingSearchAtom);
  const [scrollPosition, setScrollPosition] = useAtom(
    searchListScrollPositionAtom
  );
  const handleSearch = useAction(searchAction);
  const [filterParams] = useAtom(paramsAtom);

  const loadMore = async () => {
    if (isLoading) return;
    if (search && search?.total <= LOADING_LIMIT) return;
    if (search && search?.total <= search?.items?.length) return;

    const params: SearchParams = {
      //@ts-ignore
      page: search?.page + 1,
      limit: LOADING_LIMIT,
    };

    await handleSearch({
      params: { ...filterParams, ...params },
      next: true,
    });
  };

  return (
    <div className={s.services}>
      <div className={s.header}>
        <div className={s.titleWrapper}>
          <p className={s.title}>Все услуги</p>
          <p className={s.count}>{search?.total ?? 0}</p>
        </div>
      </div>
      <div className={clsx(!isCardView && s.padding, s.scrollable)}>
        <VirtuosoGrid
          style={{
            display: "grid",
            paddingRight: 0,
            flex: 1,
            maxHeight: "calc(100% - 45px)",
          }}
          data={[...(search?.items || []), { loader: true }]}
          totalCount={(search?.items?.length || 0) + 1}
          increaseViewportBy={{ top: 500, bottom: 800 }}
          endReached={loadMore}
          onScroll={(e) => {
            const target = e.target as HTMLElement;
            setScrollPosition(target.scrollTop);
          }}
          itemContent={(index, item) => {
            if (!item) {
              return null;
            }

            if (
              "loader" in item &&
              item.loader &&
              index !== search?.total &&
              search &&
              search?.total >= index
            ) {
              return (
                <div className={s.footer_loading}>
                  <SpinLoader />
                </div>
              );
            }
            if ("id" in item) {
              return (
                <Card
                  cssId={index === 0 ? "card" : ""}
                  key={index}
                  id={item.id}
                  src={item.preview_files[0]?.url}
                  price={`${item.price.amount.toLocaleString("ru-RU")} ₽`}
                  description={item.title}
                  waitingTime={item.days}
                />
              );
            }
          }}
          listClassName={clsx(s.gridContainer, {
            [s.cardGrid]: !isCardView,
            [s.listGrid]: isCardView,
          })}
        />
      </div>
      <CardViewSwithcer scrollY={scrollPosition} />
    </div>
  );
};
